<template>
  <img
    :src="iconPath"
    :class="{ black }"
  >
</template>

<script>
const chevronDown = require('@assets/icon/chevron-down-solid.svg');
const chevronUp = require('@assets/icon/chevron-up-solid.svg');
const envelope = require('@assets/icon/envelope-open-text-solid.svg');
const home = require('@assets/icon/home-solid.svg');
const wrench = require('@assets/icon/wrench-solid.svg');
const link = require('@assets/icon/external-link-alt-solid.svg');
const tools = require('@assets/icon/tools-solid.svg');
const exclamation = require('@assets/icon/exclamation-circle-solid.svg');

const iconMap = {
  chevronDown,
  chevronUp,
  envelope,
  home,
  wrench,
  link,
  tools,
  exclamation,
};

export default {
  name: 'CoreIcon',

  props: {
    icon: {
      validator: (value) => [null, 'chevronDown', 'chevronUp', 'envelope', 'home', 'wrench', 'link', 'tools', 'exclamation'].indexOf(value) !== -1,
      default: null,
    },
    black: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    iconPath() {
      return this.icon ? iconMap[this.icon] : '';
    },
  },
};
</script>

<style scoped>
img {
  transition-property: filter;
  transition-duration: var(--transition-short);
  transition-timing-function: var(--transition-ease);
}

.black {
  filter: invert(1);
}
</style>
